var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injector } from '@angular/core';
import { CategoryItemListPage } from './category-item-list';
import { MenuService } from '../../core/services/menu.service';
var DirectCategoryItemListPage = /** @class */ (function (_super) {
    __extends(DirectCategoryItemListPage, _super);
    function DirectCategoryItemListPage(injector, menuService) {
        var _this = _super.call(this, injector, menuService) || this;
        _this.menuService = menuService;
        _this.t.use('en');
        _this.t.currentLang = 'en';
        _this.configService.setLocale('en');
        _this.orderService.hiddenNav = true;
        return _this;
    }
    DirectCategoryItemListPage.prototype.ionViewWillEnter = function () {
        if (!this.orderManager.order) {
            var store = this.store;
            var storeId = this.storeId;
            if (store) {
                this.store = store;
                this.storeId = store.id;
                if (this.multOrderManager.enableMutlOrder) {
                    this.settingMultiOrderManager();
                }
                else {
                    this.orderManager.createOrder(this.store.id, null, null, null, this.store);
                    if (this.orderManager.mode == 'byod') {
                        this.memberService.initMember('anno');
                        this.cartService.initSharingCart(this.storeId, Number.parseInt(this.orderService.spot));
                    }
                }
                this.orderManager.settingOrderType(this.orderManager.mode);
                this.getStore(this.orderManager.mode);
            }
            else if (storeId) {
                this.storeId = storeId;
                if (this.multOrderManager.enableMutlOrder) {
                    this.settingMultiOrderManager();
                }
                else {
                    this.orderManager.createOrder(this.store.id, null, null, null, this.store);
                    if (this.orderManager.mode == 'byod') {
                        this.memberService.initMember('anno');
                        this.cartService.initSharingCart(this.storeId, Number.parseInt(this.orderService.spot));
                    }
                }
                this.orderManager.settingOrderType(this.orderManager.mode);
                this.getStore(this.orderManager.mode);
            }
        }
    };
    DirectCategoryItemListPage.prototype.getStore = function (type) {
        var _this = this;
        this.loading(true);
        this.menuService.getBKStore(this.storeId, true, type).subscribe(function (store) {
            _this.store = store;
            _this.paymentService.preload(_this.store, function () {
                _this.paymentService.checkPaymentMethodAvailable();
            });
            console.log(_this.store);
            _this.orderService.isBK = store.brand.id == 800001;
            _this.setTheme(store.brand, store);
            var _a = _this.stoppedPreOrder(store), stopped = _a[0], period = _a[1];
            if (stopped || !period) {
                _this.loading(false);
                var message = store.closedMessage ? store.closedMessage : _this.t.instant('global.no-service-message');
                _this.showAlert('', message, [{
                        text: _this.t.instant('buttons.ok'),
                        handler: function () {
                            genkiJSInterface.exitwebview();
                        }
                    }]);
            }
            else {
                _this.saveWeekDay(period);
                _this.monitoringService.listenStoreKioskStatus(store, function () {
                    _this.loading(false);
                    _this.showAlert('', _this.t.instant('global.kiosk-offline-message'), [{
                            text: _this.t.instant('buttons.ok'),
                            handler: function () {
                                genkiJSInterface.exitwebview();
                            }
                        }]);
                }, function () {
                    _this.loading(false);
                    _this.showStore(store);
                });
            }
            // this.showStore(store);
        }, function (err) { return console.error(err); }, function () {
            _this.loading(false);
        });
    };
    DirectCategoryItemListPage.prototype.isTempAccessPage = function () {
        return true;
    };
    return DirectCategoryItemListPage;
}(CategoryItemListPage));
export { DirectCategoryItemListPage };
